import React, { useState } from "react";
import { useSwipeable } from "react-swipeable";
import { ResponsiveImage, Link } from "@quintype/components";
import { getLinkTarget } from "../../../arrow/utils/utils";
import { LeftArrowIcon } from "../../../../assets/icons/LeftArrowIcon";
import { RightArrowIcon } from "../../../../assets/icons/RightArrowIcon";
import { KeyIcon } from "./icons";
import "./ceo-forum.m.css";
import "./report-slider.m.css";

export const ReportSlider = ({ reports }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [highlightPrev, setHighlightPrev] = useState(false);
  const [highlightNext, setHighlightNext] = useState(false);

  if (!reports?.length) return null;

  const totalReports = reports.length;

  const navigate = (direction) => {
    if (isAnimating) return;

    if (direction === "next" && currentIndex === totalReports - 1) {
      setHighlightPrev(true);
      setTimeout(() => setHighlightPrev(false), 2000); // Flash for 2 seconds
      return;
    }

    if (direction === "prev" && currentIndex === 0) {
      setHighlightNext(true);
      setTimeout(() => setHighlightNext(false), 2000); // Flash for 2 seconds
      return;
    }

    setHighlightPrev(false);
    setHighlightNext(false);
    setIsAnimating(true);
    setCurrentIndex((prev) =>
      direction === "next" ? prev + 1 : prev - 1
    );
    setTimeout(() => {
      setIsAnimating(false);
    }, 400); // 0.4s matches CSS transition duration
  };

  const handlePrevious = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate("prev");
  };

  const handleNext = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate("next");
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => navigate("next"),
    onSwipedRight: () => navigate("prev"),
    preventScrollOnSwipe: true,
    trackTouch: true,
    trackMouse: false,
  });

  return (
    <div styleName="slider-wrapper">
      <div styleName="slider-container" {...swipeHandlers}>
        <div styleName="slider-window">
          <div styleName="slider-track" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
            {reports.map((report, index) => {
              const { desktopSvg, entityName, reportTypeName, title, description, period, isExclusive, image, imageMetadata, url } = report;
              return (
                <div
                  key={index}

                  styleName="slider-card"
                  style={{ boxShadow: 'none' }}






                >
                  <div styleName="slider-card-top">
                    <div styleName="slider-card-left">
                      <div styleName="slider-counter slider-counter-mobile" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                        <button
                          styleName={["counter-button", currentIndex === 0 ? "disabled" : null, highlightPrev ? "highlight-prev" : null].filter(Boolean).join(" ")}
                          onClick={handlePrevious}
                          aria-label="Previous report"
                        >
                          <LeftArrowIcon />
                        </button>
                        <span styleName="counter-text">{index + 1}/{totalReports}</span>
                        <button
                          styleName={["counter-button", highlightNext ? "highlight-prev" : null].filter(Boolean).join(" ")}
                          onClick={handleNext}
                          aria-label="Next report"
                        >
                          <RightArrowIcon />
                        </button>
                      </div>
                      {desktopSvg && (
                        <div styleName="report-icon">
                          <img src={desktopSvg} alt="Report icon" />
                        </div>
                      )}
                      <p styleName="card-category">{reportTypeName || entityName}</p>
                    </div>
                    <div styleName="slider-card-right">
                      {image ? (
                        <ResponsiveImage
                          slug={image}
                          metadata={imageMetadata || {}}
                          aspectRatio={[16, 9]}
                          defaultWidth={450}
                          widths={[450]}
                          imgParams={{ auto: ["format", "compress"] }}
                          alt={title || ""}
                          styleName="slider-card-image"
                        />
                      ) : (
                        <img src="/icons/fallback_img.png" alt="" styleName="slider-card-image" />
                      )}
                      <div styleName="slider-counter slider-counter-desktop" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                        <button
                          styleName={["counter-button", currentIndex === 0 ? "disabled" : null, highlightPrev ? "highlight-prev" : null].filter(Boolean).join(" ")}
                          onClick={handlePrevious}
                          aria-label="Previous report"
                        >
                          <LeftArrowIcon />
                        </button>
                        <span styleName="counter-text">{index + 1}/{totalReports}</span>
                        <button
                          styleName={["counter-button", highlightNext ? "highlight-prev" : null].filter(Boolean).join(" ")}
                          onClick={handleNext}
                          aria-label="Next report"
                        >
                          <RightArrowIcon />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div styleName="slider-card-bottom">
                    <Link href={url} styleName="card-link-wrapper" target={getLinkTarget(url)} rel="noopener">
                      <p styleName="card-description">{title}</p>
                    </Link>
                    <div styleName="card-metadata">
                      {period && Array.isArray(period) && period.length > 0 && (
                        <p styleName="card-frequency">{period[0]}</p>
                      )}
                      <KeyIcon clipId={`clip_slider_${index}`} styleName="key-icon" />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div styleName="card-stack-container">
          {Array.from({ length: 7 }, (_, i) => (
            <div key={i + 1} styleName={`card-stack-strip card-stack-strip-${i + 1}`} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReportSlider;